module.exports = __webpack_public_path__ + "housingStatic/img/personExample.38e7d51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/personExample.png
// module id = Qb+b
// module chunks = 2